import React from "react";
import "./NavBis.css";

const NavBis = () => {
  return (
    <div>
      <nav className="navMenu">
        <a href="/country">Countries</a>
        <a href="/standing">Standings</a>
        <a href="/match">Matches</a>
        <div className="dot"></div>
      </nav>
    </div>
  );
};

export default NavBis;
